import http from "../../http";

const orgstaff = {
    getOrgStaffPage(param){
        return http.spin.get("/gateway/api/auth/pc/staffOrg/selectByPage", param);
    },
}
export default orgstaff